import { Time } from "../types";

export function formatTimeUnit({ unit, value }: Time) {
  const valueInSeconds = parseFloat(value) * timeInSeconds[unit];

  if (valueInSeconds >= timeInSeconds.days) {
    const days = Number((valueInSeconds / timeInSeconds.days).toFixed(1));
    return {
      unit: "days",
      value: days,
    };
  } else if (valueInSeconds >= timeInSeconds.hours) {
    const hours = Number((valueInSeconds / timeInSeconds.hours).toFixed(1));
    return {
      unit: "hours",
      value: hours,
    };
  } else if (valueInSeconds >= timeInSeconds.minutes) {
    const minutes = Number((valueInSeconds / timeInSeconds.minutes).toFixed(1));
    return {
      unit: "minutes",
      value: minutes,
    };
  } else {
    const seconds = Number(valueInSeconds.toFixed(1));
    return {
      unit: "seconds",
      value: seconds,
    };
  }
}

export const timeInSeconds = {
  seconds: 1,
  minutes: 60,
  hours: 3600,
  days: 86400,
};
